export interface GatePreset {
  label: string;
  lat: number;
  lng: number;
}

export interface StadiumPreset {
  name: string;
  gates: GatePreset[];
}

export const STADIUM_PRESETS: StadiumPreset[] = [
  {
    name: "AT&T Stadium",
    gates: [
      { label: "Gate A", lat: 32.7488, lng: -97.0937 },
      { label: "Gate B", lat: 32.7480, lng: -97.0930 },
      { label: "Gate C", lat: 32.7472, lng: -97.0925 },
      { label: "Gate D", lat: 32.7476, lng: -97.0915 },
      { label: "Gate E", lat: 32.7484, lng: -97.0910 },
      { label: "Lot 4 Staging", lat: 32.7465, lng: -97.0945 },
    ],
  },
  {
    name: "Arrowhead",
    gates: [
      { label: "Gate 1", lat: 39.0493, lng: -94.4842 },
      { label: "Gate 2", lat: 39.0496, lng: -94.4830 },
      { label: "Gate 3", lat: 39.0484, lng: -94.4828 },
      { label: "Gate 4", lat: 39.0480, lng: -94.4840 },
      { label: "Bus Staging", lat: 39.0470, lng: -94.4855 },
    ],
  },
];
